
import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import { updatePackageInfoRemark } from "@/api/package";
import {
  batchCreateBrand,
  batchCreateBrandTemplate,
  exportCustomerBrandList,
  getPackageInfoList
} from "@/api/brand";

import {
  getSaleAssistantList,
  getSalesmanList,
} from "@/api/inquiry";
import {queryAllCustomerBrandStates} from "@/api/brand";
import {firstUploadMark} from "@/api/mark-management";

@Component({
  name: "packageInfoManagement",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private isShowMore = false;
  private isShowMore2 = false;
  private listLoading = true;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    customerId: null,
    nation: null,
    brand: null,
    sellerId: null,
    saleAssistant: null,
    customerBrandState:null
  };
  public searchForm = [
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },

    {
      label: "销售员",
      prop: "saleId",
      key: "saleId",
      type: "select",
      options: [],
      value: "",
      placeholder: "全部",
    },
    {
      label: "国家",
      prop: "nation",
      key: "nation",
      type: "input",
      value: "",
      placeholder: "请填写国家",
    },
    {
      label: "销售助理",
      prop: "saleAssistant",
      key: "saleAssistant",
      type: "select",
      options: [],
      value: "",
    },
    {
      label: "品牌",
      prop: "brand",
      key: "brand",
      type: "input",
      value: "",
      options: [],
      placeholder: "请填写品牌",
    },
     {
      label: "客人品牌状态",
      prop: "customerBrandState",
      key: "customerBrandState",
      type: "select",
      options: [],
      placeholder: "正常使用",
      resetKey: { label: "desc", value: "name" },
    }
  ];
  public tableCol = [
    {
      label: "客人编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      show: true,
      disabled: false,
    },
    {
      label: "国家",
      prop: "nation",
      key: "nation",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      show: true,
      disabled: false,
    },
    {
      label: "销售助理",
      prop: "saleAssistant",
      key: "saleAssistant",
      show: true,
      disabled: false,
    },
    {
      label: "客人品牌",
      prop: "brands",
      key: "brands",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "唛头管理",
          code: "",
          click: "handleMark",
        },
        {
          name: "品牌管理",
          code: "",
          click: "handleBrand",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;

  created() {
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getSalesmanList();
    this.searchCustomer();
    this.getList();
    this.queryAllCustomerBrandStates();
    this.getSaleAssistantList();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
   const { total, list }: any  = await getPackageInfoList(params);
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  // 填写备注
  public async handleRemark(item) {
    try {
      await updatePackageInfoRemark(
        {
          customerId: item.customerId,
          remark: item.remark
        },
      );
      this.confirmSuccess();
    } catch (e) {
      await this.getList();
    }
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[1].options = res;
  }

  // 获取销售助理
   private async getSaleAssistantList() {
    const res: any = await getSaleAssistantList();
    this.searchForm[3].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, time2, ...rest } = params;
    if (time && time.length) {
      rest.piStartTime = time[0];
      rest.piEndTime = time[1];
    }
    if (time2 && time2.length) {
      rest.orderStartTime = time2[0];
      rest.orderEndTime = time2[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleMark(scope) {
    let item = encodeURIComponent(JSON.stringify(scope.row));
    this.$router.push(`/markManagement?customerId=${scope.row.customerId}&item=${item}`);
  }

   private handleBrand(scope) {
    let  item1 = {
      customerId: scope.row.customerId,
      customerAbbr: scope.row.customerAbbr,
      nation: scope.row.nation,
      seller: scope.row.seller,
      saleAssistant: scope.row.saleAssistant,
    }
    let item = encodeURIComponent(JSON.stringify(item1));
    this.$router.push(`/brandManagement?item=${item}`);
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private async queryAllCustomerBrandStates() {
   const states:any =  await queryAllCustomerBrandStates();
   this.searchForm[5].options = states;
  }

// 导出当前列表
  private downloadLoading = false;
  private async exportCurrentList() {
    this.downloadLoading = true;
    await exportCustomerBrandList()
    .then(() => {
      this.$notify({
        title: "成功",
        message: "导出成功",
        type: "success",
        duration: 2000,
      });
    })
    .catch((err) => {
      console.log(err);
    });
    this.downloadLoading = false;
  }
  private async handleCommand(){
    await batchCreateBrandTemplate()
    .then(() => {
      this.$notify({
        title: "成功",
        message: "导出成功",
        type: "success",
        duration: 2000,
      });
    })
    .catch((err) => {
      console.log(err);
    });
  }
  private async uploadDoc() {
     this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }

  private async batchCreateBrandUpload(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    await batchCreateBrand(formData)
    .then(() => {
      loading.close();
      this.$notify({
        title: "成功",
        message: "上传成功",
        type: "success",
        duration: 2000,
      });
    })
    .catch((err) => {
      loading.close();
      console.log(err)
    });
    this.getList();
  }

  private async uploadMark(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    await firstUploadMark(formData)
        .then(() => {
          loading.close();
          this.confirmSuccess();
        })
        .catch((err) => {
          loading.close();
          console.error(err)
        });
  }
}
